
/*@jsxRuntime automatic @jsxImportSource react*/
/*prettier-ignore*/
/*prettier-ignore*/
export const attributes = {
  "authors": ["chase-merlin", "ben-milne", "matt-franczak"],
  "callToAction": {
    "heading": "Get started",
    "subheading": "Log in to mint with ACH",
    "button": "Mint stablecoins",
    "ctaUrl": "https://app.brale.xyz/login",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "Mint and redeem stablecoins with ACH via Plaid | Brale Blog",
    "url": "/assets/blog/mint-and-redeem-stablecoins-with-ach-via-plaid/cover.png"
  },
  "date": "2024-06-06",
  "description": "Mint and redeem stablecoins with ACH without any fees. Link your bank account with Plaid to get started.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_mint-and-redeem-stablecoins-with-ach-via-activity-7204510347003580416-m30b/",
  "discussTwitter": "https://x.com/brale_xyz/status/1798743247541751881",
  "discussFarcaster": "https://warpcast.com/brale/0x1a484c6d",
  "excerpt": "Brale leverages Plaid and supports ACH stablecoin mints and redemptions without any fees.",
  "ogImage": {
    "alt": "Mint and redeem stablecoins with ACH via Plaid | Brale Blog",
    "url": "/assets/blog/mint-and-redeem-stablecoins-with-ach-via-plaid/og-image.png"
  },
  "timeOverride": 2,
  "title": "Mint and redeem stablecoins with ACH via Plaid",
  "paymentMethods": [{
    "method": "USDC, USDP",
    "mint": true,
    "redeem": true,
    "speed": "Instant",
    "fees": "Chain gas fee"
  }, {
    "method": "ACH",
    "mint": true,
    "redeem": true,
    "speed": "1-2 days",
    "fees": "Free"
  }, {
    "method": "Wire Transfer",
    "mint": true,
    "redeem": true,
    "speed": "1-2 days",
    "fees": "Free"
  }]
};
import {faCircle1, faCircle2, faCircle3, faCircle4, faCircleCheck} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    img: "img",
    tr: "tr",
    td: "td"
  }, props.components);
  return <><_components.p>{"We're happy to announce that businesses can now link bank accounts via Plaid to mint and redeem stablecoins without any fees. Bank transfers are supported alongside wire, USDC, USDP, and additional payment methods."}</_components.p>{"\n"}<_components.h2>{"Mint Stablecoins with ACH"}</_components.h2>{"\n"}<_components.p>{"Follow this example to securely link a bank account with Plaid and mint stablecoins in less than a minute."}</_components.p>{"\n"}{}{"\n"}<div className="round border border-primary not-prose my-10 bg-black overflow-clip"><_components.p><_components.img src="/assets/blog/mint-and-redeem-stablecoins-with-ach-via-plaid/mint-with-ach.gif" alt="Minting a stablecoin with ACH via Plaid" /></_components.p></div>{"\n"}<_components.p>{"To mint via ACH:"}</_components.p>{"\n"}{}{"\n"}<ul className="flex flex-col gap-4 max-w-none my-8 p-0 text-primary"><li className="m-0 border border-primary bg-secondary round flex items-start gap-3 p-6"><FontAwesomeIcon className="h-6 w-6 flex-shrink-0 m-0 mt-0.5" icon={faCircle1} /><p className="m-0">{"Add a new bank account in the settings page."}</p></li><li className="m-0 border border-primary bg-secondary round flex items-start gap-3 p-6"><FontAwesomeIcon className="h-6 w-6 flex-shrink-0 m-0 mt-0.5" icon={faCircle2} /><p className="m-0">{"Link your bank account to your Brale account."}</p></li><li className="m-0 border border-primary bg-secondary round flex items-start gap-3 p-6"><FontAwesomeIcon className="h-6 w-6 flex-shrink-0 m-0 mt-0.5" icon={faCircle3} /><p className="m-0">{"Initiate an ACH transfer from your bank account."}</p></li><li className="m-0 border border-primary bg-secondary round flex items-start gap-3 p-6"><FontAwesomeIcon className="h-6 w-6 flex-shrink-0 m-0 mt-0.5" icon={faCircle4} /><p className="m-0">{"Once the transaction is confirmed, stablecoins will be immediately minted to your wallet."}</p></li></ul>{"\n"}<_components.p>{"Stablecoins can also be redeemed to linked bank accounts on a fully 1:1 basis without fees."}</_components.p>{"\n"}<_components.h2>{"Payment methods"}</_components.h2>{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0"><thead><tr><th /><th className="text-secondary px-8 whitespace-nowrap">{"Mint"}</th><th className="text-secondary px-8 whitespace-nowrap">{"Redeem"}</th><th className="text-secondary px-8 whitespace-nowrap">{"Speed"}</th><th className="text-secondary px-8 whitespace-nowrap">{"Fees"}</th></tr></thead><tbody>{attributes.paymentMethods.map(a => <_components.tr key={a.method}>
          <_components.td className="text-primary whitespace-nowrap">{a.method}</_components.td>
          <_components.td className="text-primary px-8 whitespace-nowrap">
            {a.mint && <FontAwesomeIcon className="h-6 w-6 text-purple-500" icon={faCircleCheck} />}
          </_components.td>
          <_components.td className="text-primary px-8 whitespace-nowrap">
            {a.redeem && <FontAwesomeIcon className="h-6 w-6 text-purple-500" icon={faCircleCheck} />}
          </_components.td>
          <_components.td className="text-primary px-8 whitespace-nowrap">{a.speed}</_components.td>
          <_components.td className="text-primary px-8 whitespace-nowrap">{a.fees}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"We’ll continue to add more payment methods in the future to expand access to Brale-issued stablecoins. Please reach out to our team if you’d like to see additional methods supported."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "mint-and-redeem-stablecoins-with-ach-via-plaid.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    